var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoMiro = function SvgLogoMiro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-miro_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0Z",
    fill: "#FFD02F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.354 3.2h-2.562l2.275 3.525L11.258 3.2H8.696l2.274 4.619-4.808-4.62H3.6l2.237 5.964L3.6 20.8h2.562L10.97 8.322 8.697 20.8h2.562l4.809-13.571-2.275 13.57h2.562L21.2 5.893 16.354 3.2Z",
    fill: "#050038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-miro_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 12 12)",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgLogoMiro;